import clsx, { ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * 2026 typography presets from tailwind-config `addComponents`.
 * Registered as font-size (not text-color) so they can pair with e.g. `text-2026-muted`.
 */
const TEXT_2026_TYPOGRAPHY = [
  '2026-h1',
  '2026-h2',
  '2026-h3',
  '2026-h4',
  '2026-body1',
  '2026-body2',
  '2026-body3-semibold',
  '2026-body3-regular',
  '2026-body4',
] as const

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...TEXT_2026_TYPOGRAPHY] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
